<template>
  <div id="centro-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE RECEPCION -->
              <v-card
                :key="cardRecepcion"
                flat
                v-if="tabSelected == 'Recepcion'"
              >
                <recepcion
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></recepcion>
              </v-card>
              <!-- TAB DE CAJAS -->
              <v-card
                :key="cardCajas"
                flat
                v-if="tabSelected == 'Reporte Cajas'"
              >
                <reporte-cajas />
              </v-card>
              <!-- TAB DETALLES -->
              <v-card
                :key="cardDetalles"
                flat
                v-if="tabSelected == 'Reporte Detalles'"
              >
                <reporte-detalle />
              </v-card>
              <!-- TAB ENTREGAS -->
              <v-card
                :key="cardEntregas"
                flat
                v-if="tabSelected == 'Reporte Entregas'"
              >
                <reporte-entregas />
              </v-card>
              <!-- TAB DE INFORME -->
              <v-card
                :key="cardInforme"
                flat
                v-if="tabSelected == 'Informe Revision'"
              >
                <informe-revision
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></informe-revision>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Recepcion from "@/modules/captura/views/recepcion/RecepcionCaptura.vue";
import InformeRevision from "@/modules/captura/views/recepcion/InformeRevisionCaptura.vue";

import ReporteCajas from "@/modules/captura/views/recepcion/ReporteCajas.vue";
import ReporteDetalle from "@/modules/captura/views/recepcion/ReporteDetalle.vue";
import ReporteEntregas from "@/modules/captura/views/recepcion/ReporteEntregas.vue";

export default {
  components: {
    Recepcion,
    InformeRevision,
    ReporteCajas,
    ReporteDetalle,
    ReporteEntregas,
  },
  props: {},
  data: () => ({
    proveedor: {},
    tabs: [
      "Recepcion",
      "Reporte Cajas",
      "Reporte Detalles",
      "Reporte Entregas",
      "Informe Revision",
    ],
    contratoId: "",
    tabSelected: "Recepcion",
    activeTab: "",
    index: "",
    active_tab: "",
    cardRecepcion: 0,
    cardInforme: 10,
    cardCajas: 20,
    cardDetalles: 20,
    cardEntregas: 20,
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
      if (this.tabSelected == "Recepcion") {
        this.reloadRecepcion();
      }
      if (this.tabSelected == "Informe Revision") {
        this.reloadInforme();
      }
    },
    reloadRecepcion() {
      this.cardRecepcion += 1;
    },
    reloadInforme() {
      this.cardInforme += 11;
    },
  },
};
</script>
